const state = {
  alert: {
    active: false,
    text: null,
    color: 'primary',
    timeout: 6000,
    mode: 'normal',
    wasActive: false // used to force persisting modals
  },
  preview: {
    image: false,
    file: null
  }
}

const getters = {
  alert(state) {
    return state.alert
  }
}

const actions = {
  alert({ commit }, payload) {
    commit('START_ALERT', payload)
  },
  closeAlert({ commit }) {
    commit('STOP_ALERT')
    setTimeout(() => {
      commit('STOP_WAS_ACTIVE')
    }, 50)
  },
  previewImage({ commit }, file) {
    commit('PREVIEW_IMAGE', file)
  },
  closePreview({ commit }) {
    commit('CLOSE_PREVIEW')
  }
}

const mutations = {
  START_ALERT(state, payload) {
    state.alert.active = true
    state.alert.wasActive = true
    state.alert.text = payload.text
    if (payload.color) state.alert.color = payload.color
    if (payload.timeout) state.alert.timeout = payload.timeout
    if (payload.multiline) state.alert.mode = 'multi-line'
  },
  STOP_ALERT(state) {
    state.alert.active = false
    state.alert.text = null
    state.alert.color = 'primary'
    state.alert.timeout = 6000
    state.alert.mode = 'normal'
  },
  STOP_WAS_ACTIVE(state) {
    state.alert.wasActive = false
  },
  PREVIEW_IMAGE(state, file) {
    state.preview.image = true
    state.preview.file = file
  },
  CLOSE_PREVIEW(state) {
    state.preview.image = false
    state.preview.file = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
